<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <!-- <label class="form__label"><b>{{ $lang.profile.filter.profileVerified }}</b></label> -->
          <!-- <v-select :options="profileVerifiedOptions" v-model="selectedStatus" @input="selecteStatus"></v-select> -->
          <!-- <br><br> -->
          <v-server-table :columns="columns" :url="listUrl" :options="options" ref="myTable"
            @loaded="exports(self, 'Excel', module, 'Profiles')" name="saveStateTable">

            <template #isVerified="data">
              <CBadge :color="verifiedStatusBudget(data.row.isVerified)">{{ data.row.isVerified }}</CBadge>
            </template>
            <template #emailStatus="data">
              <CBadge :color="statusBudget(data.row.emailStatus)">{{ data.row.emailStatus }}</CBadge>
            </template>
            <template #JobTitleStatus="data">
              <CBadge :color="statusBudget(data.row.JobTitleStatus)">{{ data.row.JobTitleStatus }}</CBadge>
            </template>
            <template #planStatus="data">
              <CBadge :color="statusBudget(data.row.planStatus)">{{ data.row.planStatus }}</CBadge>
            </template>
            <template #name="data">
              <Avatar v-if="data.row.type === 'Individual'" :image="data.row.avatar" :defaultImage="data.row.avatar"
                :content="data.row.name" :isProfileListPage="true" :length="50" />
              <span v-else>
                <center> --- </center>
              </span>
            </template>
            <template #company="data">
              <Avatar v-if="data.row.type === 'Company'" :image="data.row.avatar" :defaultImage="data.row.avatar"
                :content="data.row.company" :isProfileListPage="true" :length="50" />
              <span v-else>
                <center> --- </center>
              </span>
            </template>
            <template #title="data">
              <span :title="data.row.title">{{ trimfunction(data.row.title, 20) }}</span>
            </template>
            <template #actions="data">

              <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.view_user"
                v-on:click="viewTableRow(data.row.userId)" v-if='checkPermission("list-profile")'>
                <i class="fas fa-user"></i>
              </CButton>

              <CButton color="primary" v-c-tooltip="$lang.buttons.general.view_resource"
                v-on:click="viewAllTableRow(data.row.userId)" v-if='checkPermission("list-profile")'>
                <i class="fas fa-eye"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>

    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import { Mixin } from "/src/mixins/index.js";
import Avatar from "/src/components/Avatar";
import { profile } from "/src/store/url.js";
import store from "/src/store/store.js";


export default {
  name: "Companies",
  mixins: [Mixin],
  components: {
    Avatar
  },
  props: ["profile"],
  data() {
    return {
      selectedStatus: "Pending",
      module: profile,
      self: this,
      listUrl: '/users/profiles/list?industry=1',
      profile: {
        name: '',
        isVerified: '',
        city: '',
        country: '',
        state: '',
      },
      profileVerifiedOptions: ['Pending','Verified','Registered','Rejected'],
      columns: [
        'type',
        "companyType",
        "company",
        "name",
        "isVerified",
        "emailStatus",
        "JobTitleStatus",
        'createdAt',
        "actions"
      ],
      data: [],
      options: {
        saveState: true,
        headings: {
          type: this.$lang.profile.table.type,
          companyType: this.$lang.profile.table.companyType,
          company: this.$lang.profile.table.company,
          name: this.$lang.profile.table.freelancer,
          isVerified: this.$lang.profile.table.profileStatus,
          emailStatus: this.$lang.profile.table.emailStatus,
          JobTitleStatus: this.$lang.profile.table.JobTitleStatus,
          createdAt: this.$lang.profile.table.createdAt,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ['name', 'isVerified'],
        sortable: ['name', 'isVerified', 'createdAt'],
        filterable: ['name', 'isVerified', 'createdAt'],

      }
    };
  },
  created(){
    let self = this;
    // var filterDetail = JSON.parse(localStorage.getItem("Bussiness"));
    // if(filterDetail && filterDetail.hasOwnProperty('startDate')) {
    //   self.profile.startDate = filterDetail.startDate;
    //   self.profile.endDate = filterDetail.endDate;
    //   var val = "";
    //   if(filterDetail.status == "Pending") {
    //     val = "1";
    //   }
    //   if(filterDetail.status == "Verified") {
    //     val = "2";
    //   }
    //   if(filterDetail.status == "Rejected") {
    //     val = "3";
    //   }
    //   if(filterDetail.status == "New") {
    //     val = "4";
    //   }
    //   if(val != "") {
    //     self.profile.status = {value: val, label: filterDetail.status};
    //   }
    //   this.$parent.$on('applyFilterClick', this.handleApplyFilterClick);
    //   this.$parent.$on('applyResetClick', this.handleResetClick);
    //   this.listUrl += '&selectedStatus='+filterDetail.status;
    //   self.handleApplyFilterClick();
    //   localStorage.setItem("Bussiness",null);
    // } else {
      this.$parent.$on('applyFilterClick', this.handleApplyFilterClick);
      this.$parent.$on('applyResetClick', this.handleResetClick);
      // this.listUrl += '&selectedStatus='+this.selectedStatus;
    // }
  },
  mounted() {
    
  },
  beforeDestroy() {
    this.$parent.$off('applyFilterClick', this.handleApplyFilterClick);
    this.$parent.$off('applyResetClick', this.handleResetClick);
  },
  methods: {
    selecteStatus() {
      this.$refs.myTable.customQueries = {
        "selectedStatus": this.selectedStatus
      };
      this.$refs.myTable.refresh();
    },
    handleApplyFilterClick() {
      let industry = "";
      let user = "";
      let country = "";
      let state = "";
      let city = "";
      let profileVerified = "";
      let category = "";
      let type = "";
      let startDate = "";
      let getSubIndustries = [];
      if (this.profile.industry != null) {
        industry = this.profile.industry.value;
      }
      if (this.profile.subIndustry != null) {
        this.profile.subIndustry.map(function (value, key) {
          getSubIndustries[key] = value.value;
        });
      }
      if (this.profile.user != null) {
        user = this.profile.user.value;
      }
      if (this.profile.category != null) {
        category = this.profile.category.value;
      }
      if (this.profile.type != null) {
        type = this.profile.type.value;
      }
      if (this.profile.country != null) {
        country = this.profile.country.value;
      }
      if (this.profile.state != null) {
        state = this.profile.state.value;
      }
      if (this.profile.city != null) {
        city = this.profile.city.value;
      }
      if (this.profile.profileVerified != null) {
        profileVerified = this.profile.profileVerified.value;
      }
      const reqObj = {
        industry : industry,
        subIndustry : getSubIndustries,
        user : user,
        category : category,
        type : type,
        country : country,
        state : state,
        city : city,
        profileVerified : profileVerified,
      };
      store.commit('showLoader', true);
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    handleResetClick() {
      this.profile.industry = "";
      this.profile.subIndustry = "";
      this.profile.user = {};
      this.profile.country = {};
      this.profile.state = {};
      this.profile.city = {};
      this.profile.profileVerified = {}
      store.commit('showLoader', true);
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
    viewTableRow(item) {
      console.log("item");
      const routeData = this.$router.resolve({ path: `profile/view/${(item)}` });
      window.open(routeData.href, '_blank');
    },
    viewAllTableRow(item) {
      const routeData = this.$router.resolve({ path: `profile/all/${(item)}` });
      window.open(routeData.href, '_blank');
    },
    verifiedStatusBudget(str) {
      if (str === 'Verified') {
        return 'success';
      } else if (str === 'Pending') {
        return 'warning';
      } else if (str === 'Rejectd') {
        return 'danger';
      } else if (str === 'Draft' || str === 'Registered') {
        return 'info';
      } else {
        return 'info';
      }
    },
  },
};
</script>